export enum PartnerStatus {
  Active = "active",
  Suspended = "suspended",
}
